import { SafePipe } from "./safe.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";
import { FormatHtmlToPlaintextPipe } from "./format-html-to-plaintext.pipe";
import { FormatCardNumberPipe } from "./format-card-number.pipe";
import { FormatPhoneNumberPipe } from "./format-phone-number.pipe";

export {
  SafePipe,
  SafeHtmlPipe,
  FormatHtmlToPlaintextPipe,
  FormatCardNumberPipe,
  FormatPhoneNumberPipe
};

export const CORE_PIPES = [
  SafePipe,
  SafeHtmlPipe,
  FormatHtmlToPlaintextPipe,
  FormatCardNumberPipe,
  FormatPhoneNumberPipe
];
